export class AtlExpandableTextToggleEvent extends CustomEvent<{ expanded: boolean }> {
   static EVENT_NAME = 'atl-expandable-text-toggle';

   constructor(detail: { expanded: boolean }) {
      super(AtlExpandableTextToggleEvent.EVENT_NAME, {
          detail, 
          bubbles: true, 
          composed: true,
      });
   }
}
